export default (value) => {
  // size validator
  if (!value) return true;
  const file = value;
  return (file.size < 6291456);
};
